/**
 * Reactive folder-tree UI state shared by the rail, the folders sheet and the folder context
 * menu: collapsed subtrees (`tik.collapsed`) and the "show all top-level folders" flag
 * (`tik.moreFolders`). Both persist through the helpers in `$lib/mail/folders`.
 */
import { SvelteSet } from 'svelte/reactivity';
import { readCollapsed, readMoreFolders, writeCollapsed, writeMoreFolders } from '$lib/mail/folders';

class FolderUiState {
  readonly collapsed = new SvelteSet<string>(readCollapsed());
  moreFolders = $state(readMoreFolders());

  toggleCollapsed(path: string): void {
    if (this.collapsed.has(path)) this.collapsed.delete(path);
    else this.collapsed.add(path);
    writeCollapsed(this.collapsed);
  }

  expand(path: string): void {
    if (!this.collapsed.has(path)) return;
    this.collapsed.delete(path);
    writeCollapsed(this.collapsed);
  }

  replaceCollapsed(next: ReadonlySet<string>): void {
    this.collapsed.clear();
    for (const p of next) this.collapsed.add(p);
    writeCollapsed(this.collapsed);
  }

  setMore(on: boolean): void {
    this.moreFolders = on;
    writeMoreFolders(on);
  }
}

export const folderUi = new FolderUiState();
